import type { TabId, TabsConfig } from '../../../_lib/schema/native-home-config.schema';

export const NATIVE_TAB_PATHS: Record<TabId, string> = {
  home: '/',
  book: '/book',
  bookings: '/bookings',
  packages: '/packages',
  profile: '/profile',
  membership: '/membership',
  memberships: '/memberships',
  coaches: '/coaches',
  shop: '/shop',
  contact: '/contact',
};

export const DEFAULT_NATIVE_TABS: TabId[] = ['home', 'book', 'bookings', 'packages', 'profile'];

// Tenants without packages (restaurants) get the default bar minus that tab.
export function defaultNativeTabs(hasPackages: boolean): TabId[] {
  return hasPackages ? DEFAULT_NATIVE_TABS : DEFAULT_NATIVE_TABS.filter((id) => id !== 'packages');
}

export function getNativeTabRoutes(config?: TabsConfig, hasPackages = true) {
  const items = config?.items ?? defaultNativeTabs(hasPackages).map((id) => ({ id, hidden: false }));
  return items.filter((item) => !item.hidden).map((item) => NATIVE_TAB_PATHS[item.id]);
}
